module.exports = __webpack_public_path__ + "static/media/instagram.d48fbb8c.svg";